<div *ngIf="isLoading">Loading Task List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="task" [(ngModel)]="model.task" [required]="required">
  <option *ngFor="let singleTask of tasks" [ngValue]="singleTask">{{ singleTask.name }}</option>
</select>
